import { render, staticRenderFns } from "./GQLCreate.vue?vue&type=template&id=635b82c2"
import script from "./GQLCreate.vue?vue&type=script&lang=js"
export * from "./GQLCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports